/* eslint semi: "error" */
/* eslint-disable */
let max = 10

export const getData = data => {
  var res = []
  let len = data.length
  for (let index = 0; index < len; index++) {
    const element = data[index]
    if (element[1] > max) {
      max = element[1]
    }
    res.push({
      name: element[0],
      value: element[2].split(',').concat(element[1])
    })
  }
  return res
}

export const getOption = data => {
  let dataArray = getData(data)
  const option = {
    geo: {
      name: 'Enroll distribution',
      type: 'map',
      map: 'world',
      roam:true,
      label: {
        emphasis: {
          show: false
        }
      },
      itemStyle: {
        normal: {
          areaColor: '#3FB5D7',
          borderColor: '#0DABEA',
          label: {
            show: true // 显示名称
          }
        },
        emphasis: {
          areaColor: '#76a1ae'
        }
      }
    },
    visualMap: {
      min: 0,
      max: max || 20,
      calculable: true,
      left: 'right',
      bottom: '3%',
      inRange: {
        color: ['#6FF1BC', '#FFF15F', '#FF7474']
      },
      textStyle: {
        color: '#fff'
      },
      padding:10
    },
    tooltip: {
      trigger: 'item',
      formatter: function (params) {
        return params.name + ' : ' + params.value[2]
      }
    },
    series: [
      {
        type: 'effectScatter',
        coordinateSystem: 'geo',
        zlevel: 2,
        rippleEffect: {
          period: 4,
          scale: 4,
          brushType: 'stroke'
        },
        label: {
          normal: {
            show: false,
            position: 'right',
            formatter: '{b}'
          }
        },
        symbolSize: 10,
        data: dataArray
      }
    ]
  }
  return option
}



// WEBPACK FOOTER //
// ./src/modules/tenantManager/dashboard/mapchar/chart.js